import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsBrandImageStyles {
    brandStyles?: ProductBrandStyles;
}

export const pageTitleStyles: ProductDetailsBrandImageStyles = {
    brandStyles: {
        logoImage: {
            css: css`
                margin-left: 15px;
                img {
                    max-width: 150px;
                    max-height: 150px;
                }
            `,
        },
        nameText: {
            size: 16,
            weight: "normal",
        },
    },
};

const styles = pageTitleStyles;

const ProductDetailsBrandImage: React.FC<Props> = ({ product }) => {
    if (!product.brand) {
        return null;
    }
    return (
        <ProductBrand brand={product.brand} showLogo={true} extendedStyles={styles.brandStyles} />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsBrandImage),
    definition: {
        displayName: "Brand Image",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
